import * as React from 'react'
import { useId } from 'react'

import { computeSize } from '../shared'
import type { IconProps } from '../shared'

/**
 * Instagram carousel arrow right icon with circular background and drop shadow.
 */
const ArrowRightIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 'medium', className, ...props }, ref) => {
    const computedSize = computeSize(size)
    const filterId = useId()

    return (
      <svg
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <g filter={`url(#${filterId})`}>
          <path
            d="M15 1C21.6274 1 27 6.3726 27 13C27 19.6274 21.6274 25 15 25C8.37258 25 3 19.6274 3 13C3 6.3726 8.37258 1 15 1ZM11.625 9.03906L15.7246 13.1377L11.625 17.2383L13.3926 19.0059L19.2607 13.1377L13.3926 7.27148L11.625 9.03906Z"
            fill="white"
            fillOpacity="0.8"
            shapeRendering="crispEdges"
          />
        </g>
        <defs>
          <filter
            id={filterId}
            x="0"
            y="0"
            width="30"
            height="30"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="2" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2681_41929"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2681_41929"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    )
  },
)

ArrowRightIcon.displayName = 'InstagramArrowRightIcon'

export { ArrowRightIcon }
